import { setError, setSuccessMessage } from '../App/ErrorsActions';
import * as BECaller from '../../util/apiCaller';

export const LOADING = 'PORTFOLIO_SETTING_LOADING';
export const SUCCESS_PORTFOLIOS = 'VALUE_PORTFOLIOS_SUCCESS';
export const SUCCESS_DATA = 'PORTFOLIO_SUCCESS_DATA';
export const SELECT_PORTFOLIO = 'PORTFOLIOS_SELECT';
export const NO_PORTFOLIOS = 'NO_PORTFOLIOS';

const MAX_RETRIES = 3600;

export function handleError(err, opt) {
  return setError(err, opt);
}

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function successPortfolios(data) {
  return {
    type: SUCCESS_PORTFOLIOS,
    portfolios: data
  };
}

export function noPortfolios() {
  return {
    type: NO_PORTFOLIOS
  };
}

export function successFilters(data) {
  return {
    type: SUCCESS_FILTERS,
    filters: data
  };
}

function successData(data) {
  return {
    type: SUCCESS_DATA,
    data
  };
}


export function selectPortfolio(portfolio, viewId) {
  return {
    type: SELECT_PORTFOLIO,
    selected: portfolio,
    viewId
  };
}

export function deletePortfolio(portfolioId) {
  return dispatch => {
    BECaller.api(`executive/portfolios/${portfolioId}`, 'delete').then(
      () => {
        dispatch(listAll());
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelected(id) {
  return dispatch => {
    BECaller.api(`executive/portfolios/selected`, 'put', {
      id
    }).then(
      () => {},
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelectedPortfolioBreakdown(id, chart, value) {
  return dispatch => {
    BECaller.api(`executive/portfolios/selected/chart`, 'put', {
      id,
      chart,
      value
    }).then(
      () => {},
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function listAll() {
  return (dispatch, getState) => {
    return BECaller.api(`executive/portfolios/list`, 'get').then(
      data => {
        if (data.length) {
          let selected = getState().portfolio.selectedPortfolio;
          if (selected && selected._id) {
            let selectedPortfolio = _.find(data, b => b._id == selected._id);
            selectedPortfolio && dispatch(selectPortfolio({ ...selectedPortfolio }));
          }
          dispatch(successPortfolios(_.sortBy(data, 'name')));
          return data;
        } else {
          dispatch(noPortfolios());
          return [];
        }
      },
      err => {
        dispatch(handleError(err));
        throw err;
      }
    );
  };
}

export function savePortfolio(data) {
  return (dispatch, getState) => {
    dispatch(isLoading(true));
    return BECaller.api(`executive/portfolios`, 'post', data).then(
      res => {
        dispatch(isLoading(false));
        dispatch(setSuccessMessage('Settings updated successfully'));
        dispatch(selectPortfolio({ ...res }));

        let portfolios = getState().portfolio.portfolios;
        const index = portfolios.findIndex(s => s._id === res._id);

        if (index !== -1) {
          portfolios[index] = res;
        } else {
          portfolios.push(res);
        }

        dispatch(successPortfolios(_.sortBy(portfolios, 'name')));
        return res;
      },
      err => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
        throw err;
      }
    );
  };
}

export function requestData(id) {
  const url = `executive/portfolios/${id}`;
  let retries = 0,
    timeout,
    lastVal;
  return (dispatch) => {    
    if (!id) return;
    dispatch(isLoading(true));   

    BECaller.api(url, 'get')
      .then(res => {
        if (res.stats) {
          dispatch(successData(res));
          dispatch(isLoading(false));
          return;
        } else {
          !!timeout && clearInterval(timeout);
          timeout = setInterval(poll, 1500, dispatch, res);
        }
      })
      .catch(err => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });

    function poll(dispatch, jobId) {
      if (retries >= MAX_RETRIES) {
        !!timeout && clearInterval(timeout);
        dispatch(setError('Could not load data'));
        return;
      }

      checkPullingState(jobId)
        .then(res => {
          if (res.running && !lastVal) {
            lastVal = res.progress;
          }

          if (res.noJob || res.completed || res.failed) {
            retries = 0;
            !!timeout && clearInterval(timeout);
            if (res.completed) {
              dispatch(successData(res.data));
            } else if (res.failed) {
              dispatch(setError('Something went wrong. Please try again later or contact us'));
            }
            dispatch(isLoading(false));
            return;
          }
          retries++;
        })
        .catch(err => {
          !!timeout && clearInterval(timeout);
          dispatch(setError(err));
        });

      
    }
  };
}

